import createIcon from '../../createIcon';

/**
 * @component @name LockOpen
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMTcuNUMxMy4xIDE3LjUgMTQgMTYuNiAxNCAxNS41QzE0IDE0LjQgMTMuMSAxMy41IDEyIDEzLjVDMTAuOSAxMy41IDEwIDE0LjQgMTAgMTUuNUMxMCAxNi42IDEwLjkgMTcuNSAxMiAxNy41Wk0xOCA4LjVIMTdWNi41QzE3IDMuNzQgMTQuNzYgMS41IDEyIDEuNUM5LjI0IDEuNSA3IDMuNzQgNyA2LjVIOC45QzguOSA0Ljc5IDEwLjI5IDMuNCAxMiAzLjRDMTMuNzEgMy40IDE1LjEgNC43OSAxNS4xIDYuNVY4LjVINkM0LjkgOC41IDQgOS40IDQgMTAuNVYyMC41QzQgMjEuNiA0LjkgMjIuNSA2IDIyLjVIMThDMTkuMSAyMi41IDIwIDIxLjYgMjAgMjAuNVYxMC41QzIwIDkuNCAxOS4xIDguNSAxOCA4LjVaTTE4IDIwLjVINlYxMC41SDE4VjIwLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LockOpen = createIcon('LockOpen', [
  [
    'path',
    {
      d: 'M12 17.5C13.1 17.5 14 16.6 14 15.5C14 14.4 13.1 13.5 12 13.5C10.9 13.5 10 14.4 10 15.5C10 16.6 10.9 17.5 12 17.5ZM18 8.5H17V6.5C17 3.74 14.76 1.5 12 1.5C9.24 1.5 7 3.74 7 6.5H8.9C8.9 4.79 10.29 3.4 12 3.4C13.71 3.4 15.1 4.79 15.1 6.5V8.5H6C4.9 8.5 4 9.4 4 10.5V20.5C4 21.6 4.9 22.5 6 22.5H18C19.1 22.5 20 21.6 20 20.5V10.5C20 9.4 19.1 8.5 18 8.5ZM18 20.5H6V10.5H18V20.5Z',
      key: '1fdrv2',
    },
  ],
]);

export default LockOpen;
